import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import { SNIPPET_RECONCILIATION_TYPE } from '../constants';
import { SNIPPETS_META_REMOVE_SNIPPET, snippetsPluginKey } from '../pm-plugins/main';
import type { ReconcileSnippet, SnippetsPlugin } from '../snippetsPluginType';
import { getSnippetQuickInsertKey } from '../ui/quick-insert/mapToQuickInsertItem';
import { registerConfluenceSnippets } from '../ui/quick-insert/registerConfluenceSnippets';

export const createReconcileSnippetCommand =
	(api: Parameters<SnippetsPlugin>[0]['api']): ReconcileSnippet =>
	(change) =>
	({ tr }) => {
		if (change.type === SNIPPET_RECONCILIATION_TYPE.UPSERT) {
			if (
				api?.snippets?.sharedState.currentState()?.removedSnippetIds.has(change.snippet.snippetId)
			) {
				return tr;
			}

			return registerConfluenceSnippets({
				api,
				openTemplateGallery: undefined,
				snippets: [change.snippet],
				tr,
			});
		}

		if (change.type === SNIPPET_RECONCILIATION_TYPE.REMOVE) {
			const removalTr = tr.setMeta(snippetsPluginKey, {
				type: SNIPPETS_META_REMOVE_SNIPPET,
				snippetId: change.snippetId,
			});
			if (isExperimentEnabled('platform_editor_slash_command')) {
				return removalTr;
			}

			const removeQuickInsertItem = api?.quickInsert?.commands?.removeQuickInsertItem;
			return (
				removeQuickInsertItem?.(getSnippetQuickInsertKey(change.snippetId))({ tr: removalTr }) ??
				removalTr
			);
		}

		return tr;
	};
